import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { Spinner } from '../../ui/Spinner/Spinner'
import { useAuth } from './AuthProvider'

export function ProtectedRoute() {
  const auth = useAuth()
  const location = useLocation()

  if (auth.status === 'hydrating') {
    return <Spinner fullPage label="Restoring your session" />
  }

  if (auth.status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <Outlet />
}
